import { render, staticRenderFns } from "./FuelOfferCarousel.vue?vue&type=template&id=25da0100&scoped=true"
import script from "./FuelOfferCarousel.vue?vue&type=script&lang=js"
export * from "./FuelOfferCarousel.vue?vue&type=script&lang=js"
import style0 from "./FuelOfferCarousel.vue?vue&type=style&index=0&id=25da0100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25da0100",
  null
  
)

export default component.exports